// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__yASn6","amount":"Amount_amount__31Awr","tip":"Amount_tip__2ZcWA","tipHeader":"Amount_tipHeader__3dUDw","tipsWrap":"Amount_tipsWrap__BMYzY"};